import React from 'react';
import { Box } from '@mui/material';
import TopUtilityBar from '@/components/sections/TopUtilityBar';
import HeaderNav from '@/components/sections/HeaderNav';
import HeroSection from '@/components/sections/HeroSection';
import CapabilitiesSection from '@/components/sections/CapabilitiesSection';
import ProjectsSection from '@/components/sections/ProjectsSection';
import ClientLogosSection from '@/components/sections/ClientLogosSection';
import WhyInverikaSection from '@/components/sections/WhyInverikaSection';
import ProcessTimeline from '@/components/sections/ProcessTimeline';
import RFQFormSection from '@/components/sections/RFQFormSection';
import FooterSection from '@/components/sections/FooterSection';

export const HomePage: React.FC = () => {
  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: 'background.default' }}>
      <TopUtilityBar />
      <HeaderNav />
      <main>
        <HeroSection />
        <CapabilitiesSection />
        <ProjectsSection />
        <ClientLogosSection />
        <WhyInverikaSection />
        <ProcessTimeline />
        <RFQFormSection />
      </main>
      <FooterSection />
    </Box>
  );
};

export default HomePage;
